import { type HttpErrorResponse } from '@angular/common/http';

export interface ErrorResponse {
  status: 'error';
  message: string | Record<string, string[]>;
  errors?: Record<string, string[]>;
}

export function extractFieldErrorMessages(errors: Record<string, string[]>): string | null {
  const messages = Object.values(errors)
    .flat()
    .filter((message): message is string => typeof message === 'string' && message.length > 0);

  return messages.length > 0 ? messages.join(' · ') : null;
}

export function extractErrorMessage(error: HttpErrorResponse): string | null {
  try {
    if (error.error && typeof error.error === 'object') {
      const errorBody = error.error as ErrorResponse;

      if (
        errorBody.errors &&
        typeof errorBody.errors === 'object' &&
        !Array.isArray(errorBody.errors)
      ) {
        const fieldMessages = extractFieldErrorMessages(errorBody.errors);
        if (fieldMessages) {
          return fieldMessages;
        }
      }

      if (errorBody.message) {
        if (typeof errorBody.message === 'string') {
          return errorBody.message;
        }

        if (typeof errorBody.message === 'object' && !Array.isArray(errorBody.message)) {
          const fieldMessages = extractFieldErrorMessages(errorBody.message);
          if (fieldMessages) {
            return fieldMessages;
          }
        }
      }
    }

    if (error.message) {
      return error.message;
    }

    return `An error occurred (${error.status})`;
  } catch {
    return `An error occurred (${error.status})`;
  }
}
